var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.128 3h3.744c.106 0 .195.037.268.11.073.073.11.162.11.268v17.244a.365.365 0 0 1-.11.268.365.365 0 0 1-.268.11h-3.744a.365.365 0 0 1-.268-.11.365.365 0 0 1-.11-.268V3.378c0-.106.037-.195.11-.268a.365.365 0 0 1 .268-.11zm-6.75 9h3.744c.106 0 .195.037.268.11.073.073.11.162.11.268v8.244a.365.365 0 0 1-.11.268.365.365 0 0 1-.268.11H3.378a.365.365 0 0 1-.268-.11.365.365 0 0 1-.11-.268v-8.244c0-.106.037-.195.11-.268a.365.365 0 0 1 .268-.11zm13.5-4.5h3.744c.106 0 .195.037.268.11.073.073.11.162.11.268v12.744a.365.365 0 0 1-.11.268.365.365 0 0 1-.268.11h-3.744a.365.365 0 0 1-.268-.11.365.365 0 0 1-.11-.268V7.878c0-.106.037-.195.11-.268a.365.365 0 0 1 .268-.11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestments);
export default __webpack_public_path__ + "static/media/investments.a2ffad6f4c9088a5bc4c8c3b1d321a15.svg";
export { ForwardRef as ReactComponent };